
import { Component, Vue } from "vue-property-decorator";
import { API_STORE } from "@/config";
import Axios from "axios";
import Datepicker from "vuejs-datepicker";
import { getAPIAuthorizedHeader } from "@/services/common";
import { ReportFilter } from "@/models/common";
import NewPageLoader from "@/views/NewPageLoader.vue";

@Component({ components: { Datepicker,NewPageLoader } })
export default class ClientDashboardComponent extends Vue {
  public totalRecharge = 0;
  public successRecharge = 0;
  public faildRecharge = 0;
  public rechargeCommission = 0;

  public totalDMT = 0;
  public successDMT = 0;
  public faildDMT = 0;
  public dmtCharges = 0;

  public totalAEPS = 0;
  public successAEPS = 0;
  public faildAEPS = 0;
  public aepsCommission = 0;

  public newPageLoader = false;
  public filter : any = new ReportFilter();
  public datedisablefrom: any = { from: new Date()};
  public datedisableto: any = { to: new Date()};
  public latestTransaction =[];
  public AWS_S3_URL=null;
  public broadCastMessage = null;


  public async getTotalCounts() {
      let response = await Axios.get(
        API_STORE.PORTAL + "getOtherDashboardSummary",
        {
          params: {filter: this.filter},
          headers: getAPIAuthorizedHeader(),
        }
      );
        
     if (response && response.data) {
        this.totalRecharge = response.data.data.recharge.total[0] ? response.data.data.recharge.total[0].totalAmount : '0';
        this.successRecharge = response.data.data.recharge.success[0] ? response.data.data.recharge.success[0].totalAmount : '0';
        this.faildRecharge = response.data.data.recharge.faild[0] ? response.data.data.recharge.faild[0].totalAmount : '0';
        this.rechargeCommission = response.data.data.recharge.commission[0] ? response.data.data.recharge.commission[0].totalAmount : '0';

        this.totalDMT = response.data.data.dmt.total[0] ? response.data.data.dmt.total[0].totalAmount : '0';
        this.successDMT = response.data.data.dmt.success[0] ? response.data.data.dmt.success[0].totalAmount : '0';
        this.faildDMT = response.data.data.dmt.faild[0] ? response.data.data.dmt.faild[0].totalAmount : '0';
        this.dmtCharges = response.data.data.dmt.charges[0] ? response.data.data.dmt.charges[0].totalAmount : '0';

        this.totalAEPS = response.data.data.aeps.total[0] ? response.data.data.aeps.total[0].totalAmount : '0';
        this.successAEPS = response.data.data.aeps.success[0] ? response.data.data.aeps.success[0].totalAmount : '0';
        this.faildAEPS = response.data.data.aeps.faild[0] ? response.data.data.aeps.faild[0].totalAmount : '0';
        this.aepsCommission = response.data.data.aeps.commission[0] ? response.data.data.aeps.commission[0].totalAmount : '0';

        this.latestTransaction = response.data.data.latestTransaction
      }
  }

  public getInitialFilter() {
    this.filter = new ReportFilter()
    this.filter.userId = this.$userId;
    this.filter.fromDate = new Date();
    this.filter.toDate = new Date();
    this.getTotalCounts();
  }

  public select(date, type) {
    this.filter[type] = type==='fromDate' || type==='toDate'? new Date(date): date;
    if (type == "fromDate") {
      this.datedisableto.to = new Date(date);
    }
    if (type == "toDate") {
      this.datedisablefrom.from = new Date(date);
    }
    let rangeSelected = !!this.filter.fromDate && !!this.filter.toDate;
    if (rangeSelected) {
      // this.getTotalCounts();
    }
    this.$forceUpdate();
  }

  public async getDashboardBannerimage(){
    let response = await Axios.get(
      API_STORE.COMMON + "getBannerDashboardimg", {headers: getAPIAuthorizedHeader()});   
     if(response && response.status == 200){
     this.AWS_S3_URL = process.env.VUE_APP_AWS_S3_URL+''+response.data.result.bannerImgRemotePath;
     }
  }

  public async getSystemUpdates() {
      let response = await Axios.get(API_STORE.PORTAL + "getSystemUpdates", {
        headers: getAPIAuthorizedHeader(),
      });
      if (response.data) {
        this.broadCastMessage = JSON.parse(JSON.stringify(response.data.text));
      }
  }

  mounted() {
    this.getInitialFilter();
    this.getDashboardBannerimage();
    this.getSystemUpdates();
  }
}
